import { useEffect, useState } from 'react'
import { useRouter } from '@tanstack/react-router'
import { LogOut, RefreshCw } from 'lucide-react'

import { trackLogout, trackRefresh } from '../lib/sentry-tracking'

export default function Header() {
  const router = useRouter()
  const [refreshing, setRefreshing] = useState(false)
  const [hasToken, setHasToken] = useState(false)

  useEffect(() => {
    const token = sessionStorage.getItem('teamforge_token')
    setHasToken(!!token)
  }, [])

  const handleLogout = () => {
    trackLogout()
    sessionStorage.removeItem('teamforge_token')
    setHasToken(false)
    router.navigate({ to: '/login' })
  }

  const handleRefresh = async () => {
    setRefreshing(true)
    try {
      trackRefresh()
      await router.invalidate()
    } finally {
      setRefreshing(false)
    }
  }

  if (!hasToken) {
    return null
  }

  return (
    <header className="p-4 flex items-center justify-between bg-gray-800 text-white shadow-lg">
      <h1 className="text-xl font-semibold">TeamForge Augmented</h1>
      <div className="flex items-center gap-3">
        <button
          onClick={handleRefresh}
          disabled={refreshing}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-600/50 disabled:cursor-not-allowed rounded-lg transition-colors"
          title="Refresh data"
        >
          <RefreshCw size={18} className={refreshing ? 'animate-spin' : ''} />
          <span>Refresh</span>
        </button>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
        >
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      </div>
    </header>
  )
}
